import {action, Action} from 'easy-peasy';

interface Conversation {
    conversation: any[];
}

interface EventDetails {
    [key: string]: any;
}

interface EventDetailState {
    activeCallData: Conversation;
    setActiveCallData: Action<EventDetailState, any>;
    activeChatData: Conversation;
    setActiveChatData: Action<EventDetailState, any>;
    activeEmailData: Conversation;
    setActiveEmailData: Action<EventDetailState, any>;
    activeFeedbackData: Conversation;
    setActiveFeedbackData: Action<EventDetailState, any>;
    eventDetails: EventDetails;
    setEventDetails: Action<EventDetailState, EventDetails>;
    eventIndexDetails: EventDetails;
    setEventIndexDetails: Action<EventDetailState, EventDetails>;
    eventComments: any[];
    setEventComments: Action<EventDetailState, any>;
    eventCallTranscriptionTasks: any[];
    setEventCallTranscriptionTasks: Action<EventDetailState, any[]>;
    eventCallAudioAnonymizationTasks: any[];
    setEventCallAudioAnonymizationTasks: Action<EventDetailState, any[]>;
}

const eventDetail: EventDetailState = {
    activeCallData: {conversation: []},
    setActiveCallData: action((state, callData) => {
        if (typeof callData === 'object') {
            state.activeCallData = callData;
        }
    }),
    activeChatData: {conversation: []},
    setActiveChatData: action((state, chatData) => {
        if (typeof chatData === 'object') {
            state.activeChatData = chatData;
        }
    }),
    activeEmailData: {conversation: []},
    setActiveEmailData: action((state, emailData) => {
        if (typeof emailData === 'object') {
            state.activeEmailData = emailData;
        }
    }),
    activeFeedbackData: {conversation: []},
    setActiveFeedbackData: action((state, feedbackData) => {
        if (typeof feedbackData === 'object') {
            state.activeFeedbackData = feedbackData;
        }
    }),
    eventDetails: {},
    setEventDetails: action((state, eventDetails) => {
        state.eventDetails = eventDetails;
    }),
    eventIndexDetails: {},
    setEventIndexDetails: action((state, eventIndexDetails) => {
        state.eventIndexDetails = eventIndexDetails;
    }),
    eventComments: [],
    setEventComments: action((state, eventComments) => {
        if (eventComments && eventComments.eventComments) {
            state.eventComments = eventComments.eventComments;
        } else if (Array.isArray(eventComments)) {
            state.eventComments = eventComments;
        } else {
            state.eventComments = [];
        }
    }),
    eventCallTranscriptionTasks: [],
    setEventCallTranscriptionTasks: action((state, eventCallTranscriptionTasks) => {
        state.eventCallTranscriptionTasks = eventCallTranscriptionTasks;
    }),
    eventCallAudioAnonymizationTasks: [],
    setEventCallAudioAnonymizationTasks: action((state, eventCallAudioAnonymizationTasks) => {
        state.eventCallAudioAnonymizationTasks = eventCallAudioAnonymizationTasks;
    }),
};

export default eventDetail; 